import { StyledGridColumnProps } from '@components/Grid/Grid.model';
import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const SolutionRequestButton = styled.a`
  padding: 16px 24px;
  background-color: #2a70f0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

  width: fit-content;

  &: hover {
    cursor: pointer;
  }

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 100%;
    flex: 1;
  }
`;

export const HomeSolutionLayout = styled.div`
  height: fit-content;
  max-height: 1200px;

  width: 100%;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;

export const HomeSolutionSection = styled.div`
  width: 100%;
  height: fit-content;
  max-height: 1200px;

  overflow-x: hidden;
  overflow-y: hidden;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  background-color: #071630;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    max-height: 996px;
  }

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
  }
`;

export const HomeProductCardTrack = styled.div<{ $offset: number }>`
  display: flex;
  gap: 24px;
  transform: translateX(${({ $offset }) => `${$offset}px`});
  transition: transform 0.6s ease;

  will-change: transform;
  backface-visibility: hidden;
`;

export const HomeProductCard = styled.div<{ bgImg: any }>`
  flex: 0 0 auto;

  width: 284px;
  aspect-ratio: 284 / 300;
  border-radius: 16px;
  background: #000;
  border: 1px solid rgba(0, 0, 0, 0.08);

  ${({ bgImg }) =>
    bgImg &&
    `
    background-image: url(${bgImg});
    background-size: cover;           /* ✅ 꽉 차게 */
    background-repeat: no-repeat;     /* ✅ 반복 방지 */
    background-position: center;      /* ✅ 중심 정렬 */
  `}

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: 322px;
    aspect-ratio: 322 / 300;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 322px;
    aspect-ratio: 361 / 240;
  }
`;

export const ShowLabel = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 4px;
`;

export const ImgWHRotation = styled.img<{
  w: string;
  h: string;
  rotate?: boolean;
}>`
  ${({ w }) => w && `width: ${w}px;`}
  ${({ h }) => h && `height: ${h}px;`}

  object-fit: contain; /* ✅ 비율 유지하며 꽉 채움 */
  aspect-ratio: auto; /* ✅ 원본 비율 유지 */

  transform: ${({ rotate }) => (rotate ? 'rotate(90deg)' : 'none')}; /* ✅ 회전 */
  transition: transform 0.3s ease; /* (선택) 부드러운 회전 효과 */
`;
